import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
const inspectionResultRepository = RepositoryFactory.get("inspectionResult");

const state = () => ({
  data: {}
});
const getters = {};
const mutations = {
  setInspectionResult(state, payload) {
    state.data = payload;
  }
};
const actions = {
  async loadInspectionResult(context, payload) {
    const screenId = payload.screenId;
    delete payload.screenId;
    const inspectionResults = await inspectionResultRepository.list(
      screenId,
      payload
    );
    if (inspectionResults.status < 300) {
      context.commit("setInspectionResult", inspectionResults.data);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
